var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "rd_box register" }, [
      _c("div", { staticClass: "container register step2" }, [
        _c("div", { staticClass: "title" }, [
          _vm.showView("requestRepairInfo")
            ? _c("h1", [
                _vm._v(_vm._s(_vm.$t("TITLE.REQUEST.REPAIR.INFORMATION")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showView("requestQuestion")
            ? _c("h1", [_vm._v(_vm._s(_vm.$t("TITLE.VOC.QUESTION")))])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { "ng-init": "" } }, [
          _c(
            "div",
            { staticClass: "one-register" },
            [
              _c(
                "keep-alive",
                [
                  _vm.showView("requestRepairInfo")
                    ? _c("req-repair-info", { attrs: { bIndependent: false } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showView("requestQuestion")
                    ? _c("req-question", { attrs: { bIndependent: false } })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c3fcdd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3fcdd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/EurUserMain.vue
// module id = dCbq
// module chunks = 0